import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GatherBaseComponent} from './gather-base/gather-base.component';
import {GatherFooterComponent} from './gather-shared-components/footer/gather-footer.component';
import {GatherHeaderComponent} from './gather-shared-components/header/gather-header.component';
import {GatherLoaderComponent} from './gather-shared-components/loader/loader.component';
import {GatherLandingPageComponent} from './gather-landing-page/gather-landing-page.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {GatherStateService} from './gather-services/gather-state.service';
import {GatherApiService} from './gather-services/gather-api.service';
import {LoadingService} from './gather-services/loading.service';
import {SharedDataService} from './gather-services/shared-data.service';
import {ApiWithLoadingService} from './gather-services/api-with-loading.service';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {LoaderInterceptor} from './gather-shared-components/loader/loader.interceptor';
import {GatherRoutingModule} from './gather-routing.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {AvailabilityComponent} from './availability/availability.component';
import {ConfirmComponent} from './confirm/confirm.component';
import {GatherNotInterestedComponent} from './gather-not-interested/gather-not-interested.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {GatherInvalidUuidComponent} from './gather-invalid-uuid/gather-invalid-uuid.component';
import {AlreadyATalentComponent} from './already-a-talent/already-a-talent.component';
import {JobClosedComponent} from './job-closed/job-closed.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {QuickApplyModule} from '../talent-happy-path/quick-apply/quick-apply.module';
import {TalentProfileModule} from '../talent-happy-path/talent-profile/talent-profile.module';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatDivider} from "@angular/material/divider";
import {MatDialogModule} from '@angular/material/dialog';
import {MatStepperModule} from "@angular/material/stepper";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatProgressBar} from "@angular/material/progress-bar";
import {NotAFitModalComponent} from "./gather-not-interested/modal/not-a-fit-modal.component";
import {ConfirmationModalComponent} from "../talent-happy-path/shared/components/confirmation-modal/confirmation-modal.component";
import {LocationPickerComponent} from "../talent-happy-path/shared/components/location-picker/location-picker.component";
import {MatIcon} from "@angular/material/icon";
import {MatListModule} from '@angular/material/list';

/*
NOTE: importing HttpClientModule in this submodule will cause issues down the road IF we implement an interceptor in another part of talent
      app. A refactor will be needed, but it's fine for now
*/

@NgModule({ declarations: [
        GatherBaseComponent,
        GatherFooterComponent,
        GatherHeaderComponent,
        GatherLoaderComponent,
        GatherLandingPageComponent,
        GatherNotInterestedComponent,
        AvailabilityComponent,
        ConfirmComponent,
        GatherInvalidUuidComponent,
        AlreadyATalentComponent,
        JobClosedComponent
    ],
    exports: [TranslateModule], imports: [CommonModule,
    AngularSvgIconModule.forRoot(),
    TranslateModule,
    GatherRoutingModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    QuickApplyModule,
    TalentProfileModule,
    MatDivider,
    MatProgressSpinner,
    MatStepperModule,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatProgressBar, NotAFitModalComponent, ConfirmationModalComponent, LocationPickerComponent, MatIcon], providers: [
        GatherStateService,
        GatherApiService,
        SharedDataService,
        ApiWithLoadingService,
        LoadingService,
        MatDatepickerModule,
        MatDialogModule,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class GatherModule {}
